
import { Component, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import { State } from 'vuex-class';

@Component({})
export default class ProgressBar extends Vue {
  @State progressBarStatus: boolean;
  public percent = 0;
  public show = false;
  public canSuccess = true;
  public duration = 3000;
  public height = '2px';
  public color = '#662EFF';
  public failedColor = '#ff0000';
  public _timer: any;
  public _cut: number;

  beforeDestroy() {
    if (this._timer) {
      clearInterval(this._timer);
      this.percent = 0;
    }
  }

  @Watch('progressBarStatus')
  onChangeProgressBarStatus(status: boolean) {
    return status ? this.start() : this.finish();
  }

  start() {
    this.show = true;
    this.canSuccess = true;
    if (this._timer) {
      clearInterval(this._timer);
      this.percent = 0;
    }
    this._cut = 10000 / Math.floor(this.duration);
    this._timer = setInterval(() => {
      this.increase(this._cut * Math.random());
      if (this.percent > 95) {
        this.finish();
      }
    }, 100);
    return this;
  }

  set(num: number) {
    this.show = true;
    this.canSuccess = true;
    this.percent = Math.floor(num);
    return this;
  }

  get() {
    return Math.floor(this.percent);
  }

  increase(num: number) {
    this.percent = this.percent + Math.floor(num);
    return this;
  }

  decrease(num: number) {
    this.percent = this.percent - Math.floor(num);
    return this;
  }

  finish() {
    this.percent = 100;
    this.hide();
    return this;
  }

  pause() {
    clearInterval(this._timer);
    return this;
  }

  hide() {
    clearInterval(this._timer);
    this._timer = null;
    setTimeout(() => {
      this.show = false;
      this.$nextTick(() => {
        setTimeout(() => {
          this.percent = 0;
        }, 200);
      });
    }, 500);
    return this;
  }

  fail() {
    this.canSuccess = false;
    return this;
  }
}
